import { AUTOMATED_MAILING_ROUTE_NAMES } from "automated-mailing/routes/routeNames";
import { MENU_SECTIONS, USER_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";

const meta = {
  roleRequired: [USER_ROLES.WEBMASTER],
  menuSection: MENU_SECTIONS.MANAGE,
  exactRouteIdentifier: "automatedMailings",
};

/** Webmaster automated-mailing pages, spliced into the webmaster route children. */
export const automatedMailingRouteFragment: AppRouteRecordRaw = {
  path: "automated-mailings",
  name: AUTOMATED_MAILING_ROUTE_NAMES.OVERVIEW,
  component: () => import("views/EmptyView.vue"),
  redirect: { name: AUTOMATED_MAILING_ROUTE_NAMES.MAILINGS },
  meta: { ...meta, title: "Automatische mailings", isMenuItem: true },
  children: [
    {
      path: "mailings",
      name: AUTOMATED_MAILING_ROUTE_NAMES.MAILINGS,
      component: () =>
        import("automated-mailing/pages/AutomatedMailingOverviewPage.vue"),
      meta: { ...meta, title: "Automatische mailings" },
    },
    {
      path: "log",
      name: AUTOMATED_MAILING_ROUTE_NAMES.LOG,
      component: () =>
        import("automated-mailing/pages/AutomatedMailLogPage.vue"),
      meta: { ...meta, title: "Automatische mailings" },
    },
    {
      path: "new",
      name: AUTOMATED_MAILING_ROUTE_NAMES.CREATE,
      component: () =>
        import("automated-mailing/pages/AutomatedMailingFormPage.vue"),
      meta: { ...meta, title: "Nieuwe mailing", hideTitle: true },
    },
    {
      path: ":mailingId(\\d+)",
      name: AUTOMATED_MAILING_ROUTE_NAMES.EDIT,
      component: () =>
        import("automated-mailing/pages/AutomatedMailingFormPage.vue"),
      meta: { ...meta, title: "Mailing bewerken", hideTitle: true },
    },
  ],
};
